import Model from './Model';

class Account extends Model {
  getId() {
    return this.attrs.id;
  }

  getFirstName() {
    return this.attrs.firstName;
  }

  setFirstName(value) {
    this.attrs.firstName = value;
    return this;
  }

  getLastName() {
    return this.attrs.lastName;
  }

  setLastName(value) {
    this.attrs.lastName = value;
    return this;
  }

  getFullName() {
    if (this.getLastName()) {
      return `${this.getFirstName()} ${this.getLastName()}`;
    }
    return this.getFirstName();
  }

  getType() {
    return this.attrs.type;
  }

  getEmail() {
    return this.attrs.email;
  }

  setEmail(value) {
    this.attrs.email = value;
    return this;
  }

  getMobile() {
    return this.attrs.mobile;
  }

  setMobile(value) {
    this.attrs.mobile = value;
    return this;
  }

  getImageUpdatedAt() {
    return this.attrs.imageUpdatedAt;
  }

  setImageUpdatedAt(value) {
    this.attrs.imageUpdatedAt = value;
    return this;
  }

  getStatus() {
    return this.attrs.status;
  }

  setStatus(value) {
    this.attrs.status = value;
    return this;
  }

  getLocale() {
    return this.attrs.locale;
  }

  setLocale(value) {
    this.attrs.locale = value;
    return this;
  }

  getTimeZone() {
    return this.attrs.timeZone;
  }

  setTimeZone(value) {
    this.attrs.timeZone = value;
    return this;
  }

  getCreatedAt() {
    return this.attrs.createdAt;
  }

  getUpdatedAt() {
    return this.attrs.updatedAt;
  }

  getPassword() {
    return this.attrs.password;
  }

  getOrganizationId() {
    return this.attrs.organizationId;
  }

  getLastLoginAt() {
    return this.attrs.lastLoginAt;
  }

  getSubscription() {
    return this.attrs.subscription;
  }

  getStaffRole() {
    return this.attrs.staffRole;
  }

  setStaffRole(value) {
    this.attrs.staffRole = value;
    return this;
  }
}

export default Account;
